import React from 'react';
import {Link} from "react-router-dom";

const MenuBar = () => {
    return (
        <>
            <div className="col-lg-11 dashboard-image mt-4 mr-auto ml-auto d-none d-lg-block">
                <img src="https://res.cloudinary.com/teewhy/image/upload/v1562151644/WificomngLogo.png" alt="logo" width="8%" height="10%"/>
            </div>

            <div className="col-lg-12 mt-4 mr-0 ml-0 p-0">
                <nav className="navbar navbar-expand-sm bg-dark navbar-dark shift-up shadow-md text-left" id="shift-down">
                    <Link className="navbar-brand d-block d-lg-none" to={"#"}><img src="https://res.cloudinary.com/teewhy/image/upload/v1562151644/WificomngLogo.png" width="40%" alt="images"/></Link>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse col-lg-11 m-auto p-0" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto text-left">
                            <li className="nav-item">
                                <a className="nav-link" href="https://wifi.com.ng/">
                                    Home
                                </a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link" href="https://wifi.com.ng/aboutus/">
                                    About Us
                                </a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link" href="https://wifi.com.ng/services/">
                                    Services
                                </a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link" href="https://wifi.com.ng/newuser/">
                                    Pricing
                                </a>
                            </li>

                            {/* <li className="nav-item">
                                <Link className="nav-link" to={"/"}>
                                    Pricing
                                </Link>
                            </li> */}

                            <li className="nav-item">
                                <a className="nav-link" href="https://wifi.com.ng/blog/">Blog</a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link" href="https://wifi.com.ng/newuser/">Signup</a>
                                
                            </li>

                            <li className="nav-item">
                                <a className="nav-link" href="https://dashboard.tizeti.com/">
                                    Login
                                </a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link" href="https://wifi.com.ng/contact-us/">
                                    Contact Us
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </>
    );
};

export default MenuBar;